export const transformToken = (token: string) => {
  if (!token) return "";
  return `${token?.slice(0, 15)}*****${token?.slice(-6)}`;
};

export const transformDate = (date: string) => new Date(date);

export const generateTokenUid = () => {
  const chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const randomValues = new Uint8Array(96);
  crypto.getRandomValues(randomValues);

  let result = "";
  for (let i = 0; i < 96; i++) {
    result += chars[randomValues[i] % chars.length];
  }
  return result;
};
